<template>
    <div class="v-installer-lookup-entry">
        <template v-if="company != {}">
            <div class="v-installer-lookup-entry__data">

                <div class="v-installer-lookup-entry__title">
                    {{ company.companyName }}
                </div>

                <div class="v-installer-lookup-entry__address">

                    <div class="v-installer-lookup-entry__postcode">
                        {{ company.addressZip }}
                    </div>

                    <div class="v-installer-lookup-entry__place">
                        {{ company.addressCity }}
                    </div>
                </div>
            </div>
            <div class="v-installer-lookup-entry__rating">
                <div class="v-installer-lookup-entry__star"
                     :class="{'v-installer-lookup-entry__star--active': n <= company.rating }"
                     v-for="n in 5" :key="n">
                    <i-star/>
                </div>
            </div>
        </template>

    </div>
</template>

<script>
  import iStar from "./icons/star"

  export default {
    name: "v-installer-lookup-entry",
    components: {
      iStar
    },
    props: {
      company: {
        type: Object, default() {
          return {}
        }
      }
    }
  }
</script>

<style lang="scss">
    .v-installer-lookup-entry {
        display: flex;
        justify-content: space-between;
        padding: .25em 0;
        font-size: .9em;

        &__title {
        }

        &__address {
            font-size: .9em;
            display: flex;

        }
        &__postcode {
            padding-right: .75em;
        }

        &__rating {
            display: flex;
            width: 5em;
        }
        &__star {
            fill: #f6f6f6;
            width: 6em;
            padding: .1em;

            &--active{
                fill: #FFD700;
            }
        }

    }

</style>